import { ApiConfig, handleResponse } from './config';
import type { DataShare, AudienceStats, SharedUserData } from '../../types/dataSharing';

export class DataSharingService {
  constructor(private config: ApiConfig) {}

  private getAuthHeaders(): Record<string, string> {
    const headers = { ...this.config.headers };
    if (typeof window !== 'undefined') {
      try {
        const authStorage = JSON.parse(localStorage.getItem('auth-storage') || '{}');
        const token = authStorage.state?.token;
        if (token && token !== 'null' && token !== 'undefined' && token !== '') {
          headers.Authorization = `Bearer ${token}`;
        }
      } catch {
        // Keep existing headers
      }
    }
    return headers;
  }

  async getMyShares(): Promise<DataShare[]> {
    const response = await fetch(`${this.config.baseUrl}/data-sharing/mine`, {
      headers: this.getAuthHeaders()
    });
    return handleResponse(response);
  }

  async shareWithExpert(expertId: string): Promise<DataShare> {
    const response = await fetch(`${this.config.baseUrl}/data-sharing`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify({ expertId })
    });
    return handleResponse(response);
  }

  async revokeShare(expertId: string): Promise<void> {
    const response = await fetch(`${this.config.baseUrl}/data-sharing/${expertId}`, {
      method: 'DELETE',
      headers: this.getAuthHeaders()
    });
    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.message || 'Failed to revoke share');
    }
  }

  async getAudienceStats(): Promise<AudienceStats> {
    const response = await fetch(`${this.config.baseUrl}/data-sharing/audience/stats`, {
      headers: this.getAuthHeaders()
    });
    return handleResponse(response);
  }

  async getUserSharedData(userId: string): Promise<SharedUserData> {
    const response = await fetch(`${this.config.baseUrl}/data-sharing/audience/user/${userId}`, {
      headers: this.getAuthHeaders()
    });
    return handleResponse(response);
  }
}
